export type FormattedInputType = 'cnpj' | 'cpf' | 'phone' | 'cep' | 'date';

/**
 * Remove qualquer caractere não numérico
 */
export function cleanDigits(val: string | null | undefined): string {
  if (!val) return '';
  return String(val).replace(/\D/g, '');
}

/**
 * Aplica máscara progressiva com base no tipo
 * Aceita entradas com ou sem formatação prévia
 */
export function applyProgressiveMask(type: FormattedInputType, val: string | null | undefined): string {
  if (!val) return '';
  const clean = cleanDigits(val);
  if (!clean) return '';

  switch (type) {
    case 'cnpj': {
      const raw = clean.slice(0, 14);
      if (raw.length <= 2) return raw;
      if (raw.length <= 5) return `${raw.slice(0, 2)}.${raw.slice(2)}`;
      if (raw.length <= 8) return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5)}`;
      if (raw.length <= 12) return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8)}`;
      return `${raw.slice(0, 2)}.${raw.slice(2, 5)}.${raw.slice(5, 8)}/${raw.slice(8, 12)}-${raw.slice(12)}`;
    }

    case 'cpf': {
      const raw = clean.slice(0, 11);
      if (raw.length <= 3) return raw;
      if (raw.length <= 6) return `${raw.slice(0, 3)}.${raw.slice(3)}`;
      if (raw.length <= 9) return `${raw.slice(0, 3)}.${raw.slice(3, 6)}.${raw.slice(6)}`;
      return `${raw.slice(0, 3)}.${raw.slice(3, 6)}.${raw.slice(6, 9)}-${raw.slice(9)}`;
    }

    case 'phone': {
      const raw = clean.slice(0, 11);
      if (raw.length <= 2) return `(${raw}`;
      if (raw.length <= 6) return `(${raw.slice(0, 2)}) ${raw.slice(2)}`;
      if (raw.length <= 10) return `(${raw.slice(0, 2)}) ${raw.slice(2, 6)}-${raw.slice(6)}`;
      return `(${raw.slice(0, 2)}) ${raw.slice(2, 7)}-${raw.slice(7)}`;
    }

    case 'cep': {
      const raw = clean.slice(0, 8);
      if (raw.length <= 5) return raw;
      return `${raw.slice(0, 5)}-${raw.slice(5)}`;
    }

    case 'date': {
      const raw = clean.slice(0, 8);
      if (raw.length <= 2) return raw;
      if (raw.length <= 4) return `${raw.slice(0, 2)}/${raw.slice(2)}`;
      return `${raw.slice(0, 2)}/${raw.slice(2, 4)}/${raw.slice(4)}`;
    }

    default:
      return String(val);
  }
}

export function getDefaultPlaceholder(type: FormattedInputType): string {
  switch (type) {
    case 'cnpj':
      return '00.000.000/0000-00';
    case 'cpf':
      return '000.000.000-00';
    case 'phone':
      return '(00) 00000-0000';
    case 'cep':
      return '00000-000';
    case 'date':
      return 'DD/MM/AAAA';
    default:
      return '';
  }
}

export function getMaxLengthForType(type: FormattedInputType): number {
  switch (type) {
    case 'cnpj':
      return 18; // 00.000.000/0000-00
    case 'cpf':
      return 14; // 000.000.000-00
    case 'phone':
      return 15; // (00) 00000-0000
    case 'cep':
      return 9; // 00000-000
    case 'date':
      return 10; // DD/MM/AAAA
    default:
      return 255;
  }
}
